export default {
  methods: {
    /**
     * 检查当前用户有没有权限
     * @param {*} sPermission 需要检查权限的字符串
     * @returns Boolean
     */
    hasPermission(sPermission) {
      // 没有指定权限，不需要检查
      if (!sPermission) {
        return true;
      }
      const operation_list = this?.$store?.getters?.operation_list || {};
      if (operation_list[sPermission] === true) {
        return true;
      }

      return false;
    },
  },
};
